import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../misc/guards/authenticated.guard';
import { DebugPageComponent } from './debug.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: DebugPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class DebugPageRoutingModule {}
